import { authGuard } from '@/app/core/auth/auth.guard';
import { operationGuard } from '@/app/core/auth/operation.guard';
import { guestGuard } from '@/app/core/auth/guest.guard';
import { AuthLayout } from '@/app/layout/components/app.authlayout';
import { AppLayout } from '@/app/layout/components/app.layout';
import { Notfound } from '@/app/pages/notfound/notfound';
import { Routes } from '@angular/router';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            {
                path: '',
                redirectTo: 'faturamento/notas-fiscais',
                pathMatch: 'full'
            },
            {
                path: 'account',
                loadChildren: () => import('@/app/features/account/account.routes'),
                data: { breadcrumb: 'Minha Conta' }
            },
            {
                path: 'faturamento/notas-fiscais',
                loadChildren: () => import('@/app/features/nfe/nfe.routes'),
                data: { breadcrumb: 'Notas Fiscais' }
            },
            {
                path: 'cadastros/empresas',
                loadChildren: () => import('@/app/features/company/company.routes'),
                data: { breadcrumb: 'Empresas' }
            },

            {
                path: 'cadastros/clientes',
                loadChildren: () => import('@/app/features/customer/customer.routes'),
                data: { breadcrumb: 'Clientes' }
            },
            {
                path: 'cadastros/workspaces',
                loadChildren: () => import('@/app/features/workspace/workspace.routes'),
                data: { breadcrumb: 'Workspaces' }
            },
            {
                path: 'cadastros/produtos',
                loadChildren: () => import('@/app/features/product/product.routes'),
                data: { breadcrumb: 'Produtos' }
            },
            {
                path: 'cadastros/categorias-de-produto',
                loadChildren: () => import('@/app/features/product-category/product-category.routes'),
                data: { breadcrumb: 'Categorias de Produto' }
            },
            {
                path: 'cadastros/marcas',
                loadChildren: () => import('@/app/features/product-brand/product-brand.routes'),
                data: { breadcrumb: 'Marcas' }
            },
            {
                path: 'cadastros/unidades-de-medida',
                loadChildren: () => import('@/app/features/measurement-unit/measurement-unit.routes'),
                data: { breadcrumb: 'Unidades de Medida' }
            },
            {
                path: 'cadastros/unidades-de-produto',
                loadChildren: () => import('@/app/features/product-unit/product-unit.routes'),
                data: { breadcrumb: 'Unidades do Produto' }
            },
            {
                path: 'cadastros/grupos-fiscais',
                loadChildren: () => import('@/app/features/product-fiscal-group/product-fiscal-group.routes'),
                data: { breadcrumb: 'Grupos Fiscais' }
            },
            {
                path: 'cadastros/classificacoes-fiscais',
                loadChildren: () => import('@/app/features/product-fiscal-classification/product-fiscal-classification.routes'),
                data: { breadcrumb: 'Classificações Fiscais' }
            },
            {
                path: 'cadastros/ncm',
                loadChildren: () => import('@/app/features/ncm/ncm.routes'),
                data: { breadcrumb: 'Códigos NCM' }
            },
            {
                path: 'cadastros/secoes-ncm',
                loadChildren: () => import('@/app/features/ncm-section/ncm-section.routes'),
                data: { breadcrumb: 'Seções NCM' }
            },
            {
                path: 'cadastros/tabelas-de-preco',
                loadChildren: () => import('@/app/features/product-price-list/product-price-list.routes'),
                data: { breadcrumb: 'Tabelas de Preço' }
            },
            {
                path: 'cadastros/precos-de-produto',
                loadChildren: () => import('@/app/features/product-price/product-price.routes'),
                data: { breadcrumb: 'Preços de Produto' }
            },
            {
                path: 'configuracoes/cfop',
                loadChildren: () => import('@/app/features/cfop/cfop.routes'),
                data: { breadcrumb: 'CFOP' }
            },
            {
                path: 'configuracoes/grupos-cfop',
                loadChildren: () => import('@/app/features/cfop-group/cfop-group.routes'),
                data: { breadcrumb: 'Grupo de CFOP' }
            },
            {
                path: 'configuracoes/paises',
                loadChildren: () => import('@/app/features/country/country.routes'),
                data: { breadcrumb: 'Países' }
            },
            {
                path: 'configuracoes/unidades-federativas',
                loadChildren: () => import('@/app/features/federative-unit/federative-unit.routes'),
                data: { breadcrumb: 'Unidades Federativas' }
            },
            {
                path: 'configuracoes/municipios',
                loadChildren: () => import('@/app/features/municipality/municipality.routes'),
                data: { breadcrumb: 'Municípios' }
            },
            {
                path: 'configuracoes/cidades',
                loadChildren: () => import('@/app/features/city/city.routes'),
                data: { breadcrumb: 'Cidades' }
            },
            {
                path: 'configuracoes/logradouros',
                loadChildren: () => import('@/app/features/public-place/public-place.routes'),
                data: { breadcrumb: 'Logradouros' }
            },
            {
                path: 'configuracoes/segmentos-de-negocio',
                loadChildren: () => import('@/app/features/business-segment/business-segment.routes'),
                data: { breadcrumb: 'Segmentos de Negócio' }
            },
            {
                path: 'configuracoes/cnae/secoes',
                loadChildren: () => import('@/app/features/cnae/cnae-section/cnae-section.routes'),
                data: { breadcrumb: 'CNAE - Seções' }
            },
            {
                path: 'configuracoes/cnae/divisoes',
                loadChildren: () => import('@/app/features/cnae/cnae-division/cnae-division.routes'),
                data: { breadcrumb: 'CNAE - Divisões' }
            },
            {
                path: 'configuracoes/cnae/grupos',
                loadChildren: () => import('@/app/features/cnae/cnae-group/cnae-group.routes'),
                data: { breadcrumb: 'CNAE - Grupos' }
            },
            {
                path: 'configuracoes/cnae/classes',
                loadChildren: () => import('@/app/features/cnae/cnae-class/cnae-class.routes'),
                data: { breadcrumb: 'CNAE - Classes' }
            },
            {
                path: 'configuracoes/cnae/subclasses',
                loadChildren: () => import('@/app/features/cnae/cnae-subclass/cnae-subclass.routes'),
                data: { breadcrumb: 'CNAE - Subclasses' }
            },
            {
                path: 'configuracoes/permissoes/operacoes',
                canActivate: [operationGuard('authorization_operation:list')],
                loadChildren: () => import('@/app/features/authorization/operation/operation.routes'),
                data: { breadcrumb: 'Operações' }
            },
            {
                path: 'configuracoes/permissoes/funcionalidades',
                canActivate: [operationGuard('authorization_feature:list')],
                loadChildren: () => import('@/app/features/authorization/feature/feature.routes'),
                data: { breadcrumb: 'Funcionalidades' }
            },
            {
                path: 'configuracoes/permissoes/perfis',
                canActivate: [operationGuard('authorization_profile:list')],
                loadChildren: () => import('@/app/features/authorization/profile/profile.routes'),
                data: { breadcrumb: 'Perfis' }
            },
            {
                path: 'configuracoes/permissoes/grupos',
                canActivate: [operationGuard('authorization_group:list')],
                loadChildren: () => import('@/app/features/authorization/group/group.routes'),
                data: { breadcrumb: 'Grupos' }
            },
            {
                path: 'configuracoes/permissoes/usuarios',
                canActivate: [operationGuard('authorization_account:list')],
                loadChildren: () => import('@/app/features/authorization/account/account.routes'),
                data: { breadcrumb: 'Usuários' }
            }
        ]
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                canActivate: [guestGuard],
                loadComponent: () => import('@/app/pages/auth/login').then((c) => c.Login)
            },
            {
                path: 'forgot-password',
                canActivate: [guestGuard],
                loadComponent: () => import('@/app/pages/auth/forgot-password/forgot-password').then((c) => c.ForgotPassword)
            },
            {
                path: 'reset-password',
                canActivate: [guestGuard],
                loadComponent: () => import('@/app/pages/auth/reset-password/reset-password').then((c) => c.ResetPassword)
            }
        ]
    },
    { path: 'notfound', component: Notfound, canActivate: [authGuard] },
    { path: '**', redirectTo: '/notfound' }
];
